import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
interface SettingsState {
    showSettingsModal: boolean;
}

const initialState: SettingsState = {
    showSettingsModal: false,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setShowSettingsModal: (state, { payload }: PayloadAction<boolean>) => {
            state.showSettingsModal = payload;
        },
    },
});

export const getSettingsState = (state: RootState) => state.settings;

export const getShowSettingsModal = createSelector(
    [getSettingsState],
    settings => settings.showSettingsModal
);

export const settingsInitialState = settingsSlice.getInitialState();
export const settingsReducer = settingsSlice.reducer;
export const { setShowSettingsModal } = settingsSlice.actions;
